import React from 'react';
import picture from '../../../assets/images/profile.jpeg';
import './ProfilePicture.css';

export const ProfilePicture = () => {
    return (
        <img src={picture} className="profile-picture" alt="Diego Escobar" />
    )
};


// WEBPACK FOOTER //
// ./src/components/profile-container/profile-picture/ProfilePicture.jsx